const Parking = props => {
    return (
        <svg className={props.className || ""} viewBox="0 -960 960 960" ><path d="M260-140v-680h260q91.15 0 155.58 64.42Q740-691.15 740-600t-64.42 155.58Q611.15-380 520-380H380v240H260Zm120-360h144.92q41.25 0 70.63-29.37 29.37-29.38 29.37-70.63t-29.37-70.63Q566.17-700 524.92-700H380v200Z"/></svg>
    )
}

export default Parking;